export function placeOutflows({ outflows, days, today, visibleDates }) {
  const out = {};
  const push = (date, item) => (out[date] ??= []).push(item);
  for (const o of outflows) {
    const overdue = o.status === 'scheduled' && o.due_date < today;
    if (overdue) push(today, { ...o, overdue: true });
    else if (visibleDates.includes(o.due_date)) push(o.due_date, o);
  }
  for (const [date, byAccount] of Object.entries(days || {})) {
    for (const [account, items] of Object.entries(byAccount)) {
      for (const it of items) if (it.display_only) push(date, { ...it, bank_account_id: Number(account) });
    }
  }
  return out;
}
